import React from "react";
import { FooterWarper } from "./FooterStyled";

const Footer = () => {
    return (
        <FooterWarper>
            <p>Made with 💖 </p>
        </FooterWarper>
    );
};

export default Footer;
